<h1 mat-dialog-title>Fuzzy score test</h1>

<div mat-dialog-content>

  <div fxLayout="column" [formGroup]="form">
    <mat-form-field class="example-full-width">
      <mat-label>Text 1</mat-label>
      <input matInput placeholder="Text 1" [formControl]="form.controls.text1">
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>Text 2</mat-label>
      <input matInput placeholder="Text 2" [formControl]="form.controls.text2">
    </mat-form-field>
  </div>

  @if (isLoading) {
    <mat-progress-spinner mode="indeterminate" color="primary" [diameter]="40"></mat-progress-spinner>
  }


  <table  [class.grid-loading]="isLoading" mat-table [dataSource]="testResults">

    <ng-container matColumnDef="algorithm">
      <th mat-header-cell *matHeaderCellDef> Algorithm </th>
      <td mat-cell *matCellDef="let item"> {{ item.algorithm }} </td>
    </ng-container>

    <ng-container matColumnDef="score">
      <th mat-header-cell *matHeaderCellDef> Score </th>
      <td mat-cell *matCellDef="let item"> {{ item.score }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['algorithm', 'score']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['algorithm', 'score'];"></tr>
  </table>

</div>

<div mat-dialog-actions>
  <lib-button variant="raised" mat-dialog-close>Close</lib-button>
</div>